export const GET_PRODUCTS_PRODUCTS = 'GET_PRODUCTS_PRODUCTS';
export const GET_PRODUCTS_PRODUCTS_LOADING = 'GET_PRODUCTS_PRODUCTS_LOADING';
export const GET_PRODUCTS_PRODUCTS_ERROR = 'GET_PRODUCTS_PRODUCTS_ERROR';

export const GET_PRODUCTS_TYPES = 'GET_PRODUCTS_TYPES';
export const GET_PRODUCTS_TYPES_LOADING = 'GET_PRODUCTS_TYPES_LOADING';
export const GET_PRODUCTS_TYPES_ERROR = 'GET_PRODUCTS_TYPES_ERROR';

export const GET_CATEGORIES_PRODUCTS = 'GET_CATEGORIES_PRODUCTS';
export const GET_CATEGORIES_PRODUCTS_LOADING = 'GET_CATEGORIES_PRODUCTS_LOADING';
export const GET_CATEGORIES_PRODUCTS_ERROR = 'GET_CATEGORIES_PRODUCTS_ERROR';

export const GET_CATEGORIES_PRODUCTS_BY_ID = 'GET_CATEGORIES_PRODUCTS_BY_ID';
export const GET_CATEGORIES_PRODUCTS_BY_ID_LOADING = 'GET_CATEGORIES_PRODUCTS_BY_ID_LOADING';
export const GET_CATEGORIES_PRODUCTS_BY_ID_ERROR = 'GET_CATEGORIES_PRODUCTS_BY_ID_ERROR';

export const CREATE_CATEGORIES_PRODUCTS = 'CREATE_CATEGORIES_PRODUCTS';
export const CREATE_CATEGORIES_PRODUCTS_LOADING = 'CREATE_CATEGORIES_PRODUCTS_LOADING';
export const CREATE_CATEGORIES_PRODUCTS_ERROR = 'CREATE_CATEGORIES_PRODUCTS_ERROR';
export const CREATE_CATEGORIES_PRODUCTS_RESET_STATE = 'CREATE_CATEGORIES_PRODUCTS_RESET_STATE';

export const GET_SUBCATEGORIES_PRODUCTS_BY_ID = 'GET_SUBCATEGORIES_PRODUCTS_BY_ID';
export const GET_SUBCATEGORIES_PRODUCTS_BY_ID_LOADING = 'GET_SUBCATEGORIES_PRODUCTS_BY_ID_LOADING';
export const GET_SUBCATEGORIES_PRODUCTS_BY_ID_ERROR = 'GET_SUBCATEGORIES_PRODUCTS_BY_ID_ERROR';

export const UPDATE_CATEGORIES_PRODUCTS_BY_ID = 'UPDATE_CATEGORIES_PRODUCTS_BY_ID';
export const UPDATE_CATEGORIES_PRODUCTS_BY_ID_LOADING = 'UPDATE_CATEGORIES_PRODUCTS_BY_ID_LOADING';
export const UPDATE_CATEGORIES_PRODUCTS_BY_ID_ERROR = 'UPDATE_CATEGORIES_PRODUCTS_BY_ID_ERROR';

export const CREATE_SUBCATEGORIES_PRODUCTS = 'CREATE_SUBCATEGORIES_PRODUCTS';
export const CREATE_SUBCATEGORIES_PRODUCTS_LOADING = 'CREATE_SUBCATEGORIES_PRODUCTS_LOADING';
export const CREATE_SUBCATEGORIES_PRODUCTS_ERROR = 'CREATE_SUBCATEGORIES_PRODUCTS_ERROR';

export const GET_PRODUCTS = 'GET_PRODUCTS';
export const GET_PRODUCTS_LOADING = 'GET_PRODUCTS_LOADING';
export const GET_PRODUCTS_ERROR = 'GET_PRODUCTS_ERROR';

export const UPDATE_CATEGORIES_PRODUCTS_RESET_STATE = 'UPDATE_CATEGORIES_PRODUCTS_RESET_STATE';